import type { ReactNode } from 'react'
import { Gauge } from '../icons'

interface Props {
  label?: string
  count?: string
  showPanelButton?: boolean
  onPanelClick?: () => void
  children?: ReactNode
  variant?: 'default' | 'panel'
}

export function SectionHead({ label, count, showPanelButton, onPanelClick, children, variant = 'default' }: Props) {
  return (
    <div className={`section-head${variant === 'panel' ? ' section-head--panel' : ''}`}>
      {label && <span className="section-head__label">{label}</span>}
      {count != null && <span className="section-head__count">{count}</span>}
      {children}
      {showPanelButton && (
        <button className="section-head__panel-btn" type="button" onClick={onPanelClick}>
          <Gauge />
          <span>Panoramica</span>
        </button>
      )}
    </div>
  )
}
